import React, { useEffect, useState } from "react";
import { ReactSortable } from "react-sortablejs";

const DraggableList = ({ items, onChangeHandler }) => {
  const sortableOptions = {
    animation: 150,
    fallbackOnBody: true,
    swapThreshold: 0.65,
    ghostClass: "ghost",
    group: "shared",
  };
  const [state, setState] = useState(items);

  useEffect(() => {
    onChangeHandler(state);
  }, [state]);

  return (
    <ReactSortable list={state} setList={setState} {...sortableOptions}>
      {state.map((item) => (
        <div className="group ui-accordion">
          <div className="ui-state-active ui-accordion-icons" key={item.id}>
            {item.name}
          </div>
        </div>
      ))}
    </ReactSortable>
  );
};

export default DraggableList;
